import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../../pagination.js';

export const ListPlacesQuerySchema = PaginationSchema.extend({
  active: z
    .enum(['true', 'false'])
    .optional()
    .transform((value) => (value === undefined ? undefined : value === 'true')),
  organizationId: z.uuid().optional(),
  q: z.string().trim().min(2).optional(),
});

export type ListPlacesQuery = z.infer<typeof ListPlacesQuerySchema>;

export const PlaceListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  tradeName: z.string(),
  documentNumber: z.string(),
  active: z.boolean(),
  isCentralDistribution: z.boolean(),
  organizationId: z.uuid(),
  organizationName: z.string(),
  createdAt: z.string(),
});

export type PlaceListItem = z.infer<typeof PlaceListItemSchema>;

export const ListPlacesResponseSchema = z.object({
  items: z.array(PlaceListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListPlacesResponse = z.infer<typeof ListPlacesResponseSchema>;
